/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pcr_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pipetting loses a little volume each transfer. Preparing 5–10% extra ensures the final reactions still receive a full, accurate amount.`)
};

const es_pcr_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El pipeteo pierde algo de volumen en cada transferencia. Preparar un 5–10% extra asegura que las últimas reacciones reciban también una cantidad completa y precisa.`)
};

const de_pcr_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beim Pipettieren geht bei jedem Transfer etwas Volumen verloren. Ein Ansatz von 5–10 % mehr stellt sicher, dass auch die letzten Reaktionen noch eine volle, genaue Menge erhalten.`)
};

const nl_pcr_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bij elke overdracht gaat door pipetteren een beetje volume verloren. Door 5–10% extra klaar te maken, krijgen de laatste reacties nog steeds een volledige, nauwkeurige hoeveelheid.`)
};

const fr_pcr_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chaque transfert de pipetage entraîne une légère perte de volume. Préparer 5 à 10 % en plus garantit que les dernières réactions reçoivent encore une quantité complète et précise.`)
};

const it_pcr_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il pipettaggio comporta una piccola perdita di volume a ogni trasferimento. Preparare il 5–10% in più garantisce che le reazioni finali ricevano comunque una quantità completa e accurata.`)
};

const pt_br2_pcr_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A pipetagem perde um pouco de volume a cada transferência. Preparar 5–10% a mais garante que as últimas reações ainda recebam uma quantidade completa e precisa.`)
};

const pt_pcr_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A pipetagem perde um pouco de volume em cada transferência. Preparar 5–10% a mais garante que as últimas reações ainda recebem uma quantidade completa e correta.`)
};

const ja_pcr_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ピペッティングのたびにわずかな量が失われます。5〜10%多く調製することで、最後の反応にも正確な量が行き渡ります。`)
};

const zh_pcr_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每次移液都会损失少量体积。多配制 5%–10% 可确保最后几个反应仍能获得完整、准确的用量。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pcr_faq_a2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pcr_faq_a2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pcr_faq_a2", locale)
	if (locale === "en") return en_pcr_faq_a2(inputs)
	if (locale === "es") return es_pcr_faq_a2(inputs)
	if (locale === "de") return de_pcr_faq_a2(inputs)
	if (locale === "nl") return nl_pcr_faq_a2(inputs)
	if (locale === "fr") return fr_pcr_faq_a2(inputs)
	if (locale === "it") return it_pcr_faq_a2(inputs)
	if (locale === "pt-BR") return pt_br2_pcr_faq_a2(inputs)
	if (locale === "pt") return pt_pcr_faq_a2(inputs)
	if (locale === "ja") return ja_pcr_faq_a2(inputs)
	return zh_pcr_faq_a2(inputs)
};